<template lang="html">

    <div :class="['pe_notification', { 'pe_active': isOpen }]" @click="close">
        <icon-cross />
        {{ message }}
    </div>

</template>


<script lang="js">

import Cross from '@puzzleapps/shared/src/components/ui/icons/Cross'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'notification',
    components: {
        'icon-cross': Cross,
    },

    data() {
        return {

        }
    },

    methods: {
        ...mapActions({
            setMessage: 'notification/setMessage',
            setIsOpen: 'notification/setIsOpen',
        }),

        close() {
            this.setIsOpen(false)
        }
    },

    computed: {
        ...mapState({
            message: state => state.notification.message,
            isOpen: state => state.notification.isOpen,
        }),
    }

}

</script>


<style scoped lang="scss">
@import '@puzzleapps/shared/src/style/variables';

.pe_cross {
    position: absolute;
    width: 12px;
    height: 12px;
    top: 6px;
    right: 6px;
}

.pe_notification {
    cursor: pointer;
    font-size: 1.2em;
    text-align: center;
    background: var(--primary-color);
    padding: 1em 2em;
    box-shadow: 0px 6px 9px 0px rgba(0, 0, 0, 0.27);
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: inline-block;
    position: absolute;
    transform: translate(-50%, 20%);
    bottom: 2em;
    transition: all .3s;
    opacity: 0;
    visibility: hidden;
    z-index: 99999;
    font-weight: bold;

    &.pe_active {
        transform: translate(-50%, 0);
        opacity: 1;
        visibility: visible;
    }

}
</style>
